import { useSharedContext } from './../../../../context/shared.context'
import { useQuery } from 'react-query'
import {
	loadActivityStatusAndFormsListQuery,
	loadSubmittedFormListQuery,
} from './../../../../query/form.query'
import StatusFormListUI from './statusFormListUI'
import { loadTimelineStatusQuery } from './../../../../query/activity.query'
import { getActivityStatusLifeCycleKey } from '../../../../query/queryKey/activity.queryKey'
import { createStatusAndFormsList } from './statusFormListing.util'

const StatusFormListing = () => {
	const {
		state: { activity },
	} = useSharedContext()

	const getInitialStatusAndFormsData = async () => {
		let statusAndFormsList = []

		const statusAndFormsPromise = loadActivityStatusAndFormsListQuery({
			activity_type_category_id: activity.activity_type_category_id,
			activity_type_id: activity.activity_type_id,
		})

		const submittedFormPromise = loadSubmittedFormListQuery({
			flag: 1,
			form_id: 0, // form id should be 0 to load all forms
			activity_id: activity.activity_id,
			activity_type_id: activity.activity_type_id,
			activity_type_category_id: activity.activity_type_category_id,
		})

		const timelineStatusPromise = loadTimelineStatusQuery({
			flag: -1,
			activity_id: activity.activity_id,
			activity_status_id: null,
			page_start: 0,
			page_limit: 50,
		})

		try {
			await Promise.all([
				statusAndFormsPromise,
				submittedFormPromise,
				timelineStatusPromise,
			]).then(values => {
				statusAndFormsList = createStatusAndFormsList(
					activity,
					values[0],
					values[1],
					values[2]
				)
			})
		} catch (err) {
			console.error(err)
		} finally {
			return statusAndFormsList
		}
	}

	const { data: statusAndFormsList, isLoading: loadingStatusFormsListData } =
		useQuery(
			getActivityStatusLifeCycleKey.activity_param({
				activity_id: activity.activity_id,
				activity_type_id: activity.activity_type_id,
				activity_type_category_id: activity.activity_type_category_id,
				page_start: 0,
			}),
			getInitialStatusAndFormsData,
			{
				staleTime: 10 * 1000,
				refetchOnMount: true,
			}
		)

	return (
		<>
			<StatusFormListUI
				statusAndFormsList={statusAndFormsList}
				isLoading={loadingStatusFormsListData}
			/>
		</>
	)
}

export { StatusFormListing }
